export const track_event = (event: string): void => {
  if (typeof window === 'undefined') return;
  if (typeof window.clarity !== 'function') return;
  window.clarity('set', 'smartscan_event', event);
};
